import { useContextTranslation } from '@core/i18n';
import { ProductImageFallbackContainer, ProductImageParagraph, } from './ProductCardImageFallback.styles';
/**
 Fallback used when Product Card's Image is not loaded properly,
 for example returning 404 of malformed URL
 */
export const ProductCardImageFallback = ({ compactSize }) => {
    const { t } = useContextTranslation();
    return (<ProductImageFallbackContainer compactSize={compactSize}>
      <ProductImageParagraph>
        {t('player:No image available')}
      </ProductImageParagraph>
    </ProductImageFallbackContainer>);
};
